import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { isOperatorUser } from '../auth/routing'

export const RequireMarketUser = ({ children }: { children: ReactNode }) => {
  const { session, loading, userRoles } = useAuth()

  if (loading) {
    return (
      <main className="market-login">
        <p className="market-muted">Загрузка…</p>
      </main>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace />
  }

  if (isOperatorUser(userRoles)) {
    return <Navigate to="/operator" replace />
  }

  return children
}
